const META_TAG_LOADING = "META_TAG_LOADING";
const META_TAG_ERROR = "META_TAG_ERROR";
const META_TAG_SUCCESS = "META_TAG_SUCCESS";
export { META_TAG_LOADING, META_TAG_ERROR, META_TAG_SUCCESS };
